import {DrawerProps} from '@mantine/core';
import { FilterForm } from '../forms/FilterForm/FilterForm';
import {PlatformDrawer} from '@flexinet/ui-components';

export const FilterDrawer = ({
    opened,
    onClose,
    ...rest
}: DrawerProps) => {
    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title="Filter Accounts"
            size="md"
            {...rest}
        >
            <FilterForm
                onApply={() => onClose()}
                onCancel={onClose}
            />
        </PlatformDrawer>
    );
};